import React, { useState } from 'react';
import '../App.css';
import TopBarChinese from "../components/TopBarChinese";
import ContactFormChinese from "../components/ContactFormChinese";
import TeamCard from "../components/TeamCard";
import FooterChinese from "../components/FooterChinese";
import SplashScreen from "../components/SplashScreen";
import healthcareImage from "../images/senior_hand_hold.jpg";
import jamesImage from "../images/james.jpg";
import { Link } from "react-router-dom";

function HomeChinese() {
  const [showSplash, setShowSplash] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(0);

  // Slideshow effect
  React.useEffect(() => {
    const slides = document.querySelectorAll('.slide-image');
    const interval = setInterval(() => {
      slides[currentSlide].classList.remove('active');
      const nextSlide = (currentSlide + 1) % slides.length;
      slides[nextSlide].classList.add('active');
      setCurrentSlide(nextSlide);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [currentSlide]);

  return (
    <div className="App">
      {showSplash && <SplashScreen onComplete={() => setShowSplash(false)} />}
      <TopBarChinese />
      <div className="App-header" style={{ position: 'relative', minHeight: '400px', backgroundImage: `url(${healthcareImage})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '100%', boxSizing: 'border-box' }}>
        <div className="hero-text" style={{ position: 'relative', zIndex: 2, background: 'rgba(255,255,255,0.6)', borderRadius: '16px', padding: 'clamp(16px, 4vw, 32px)', maxWidth: '90%', width: '600px', margin: '48px auto' }}>
          <h1 className="hero-title" >照顧您的家人</h1>
          <p className="hero-subtitle">
            金錢無法買到更多的健康、時間或精力，但我們可以幫助您改善這些狀況。
我們的使命是協助您找到最合適的照護專業人員。
          </p>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
          <Link to="/zhservices" onClick={() => window.scrollTo(0, 0)}>
            <button className='button-arrow'>我們的服務</button>
          </Link>
        </div>
        </div>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.25)', zIndex: 1 }}></div>
      </div>

      <div className="App-header-second">
        <div className="hero-text-left">
          <h1 className="hero-title-2">我們提供的服務</h1>
          <p className="hero-subtitle-2">
            找到合適的護理很簡單。我們提供方便的功能和服務，幫助您輕鬆照顧健康。
          </p>
        </div>
  <div className="team-cards-container" style={{ justifyContent: 'center', display: 'flex', gap: '24px' }}>
          <TeamCard
            name="預約，簡便無憂"
            description="透過我們友善的平臺，輕鬆預約看診。只需幾個步驟，您就能在方便的時間安排就診。"
            image={jamesImage}
            target="/zhbookingform"
            onClick={(e) => {
              e.preventDefault(); // Prevent default link behavior
              window.scrollTo({ top: 0, behavior: 'smooth' }); // Smooth scroll to top
            }}
          />
          <TeamCard
            name="日曆追蹤"
            description="透過我們的整合日曆功能，輕鬆追蹤您的健康預約和重要日期。保持有序，絕不錯過檢查。"
            image={jamesImage}
            target="/zhcalendar"
            onClick={(e) => {
              e.preventDefault(); // Prevent default link behavior
              window.scrollTo({ top: 0, behavior: 'smooth' }); // Smooth scroll to top
            }}
          />
          <TeamCard
            name="滿足您所有健康需求"
            description="選擇廣泛的服務，以滿足您的健康和福祉需求。從常規檢查到專科護理，我們都能為您提供支持。"
            image={jamesImage}
            target="/zhservices"
            onClick={(e) => {
              e.preventDefault(); // Prevent default link behavior
              window.scrollTo({ top: 0, behavior: 'smooth' }); // Smooth scroll to top
            }}
          />
          <TeamCard
            name="保持知悉 ，緊密聯繫"
            description="隨時了解最新的健康資訊和資源。我們的平台提供有價值的資訊，幫助您做出明智的護理決策。"
            image={jamesImage}
            target="/zhconnect"
            onClick={(e) => {
              e.preventDefault(); // Prevent default link behavior
              window.scrollTo({ top: 0, behavior: 'smooth' }); // Smooth scroll to top
            }}
          />
        </div>
      </div>
      <div className='Quote-header'>
        <div className="quote-background">
          <div className="slideshow-container">
            <div className="slideshow-images">
              <img src="/caring1.jpg" alt="Caring moment 1" className="slide-image active" style={{ objectPosition: 'center 15%' }} />
              <img src="/caring2.jpg" alt="Caring moment 2" className="slide-image caring2-image" />
              <img src="/caring3.jpg" alt="Caring moment 3" className="slide-image caring3-image" />
              <img src="/caring4.jpg" alt="Caring moment 4" className="slide-image caring4-image" />
              <img src="/caring8.jpg" alt="Caring moment 5" className="slide-image caring5-image" />
              <img src="/caring10.jpg" alt="Caring moment 6" className="slide-image caring6-image" />
            </div>
          </div>
          <div id="subtitle-quote" className='quote-section'>
在 Connection Health Care（CHC），我們提供的不僅是照護，更是安心與信賴。
我們以對待家人的態度，給予每一位您所愛的人同等的尊重與尊嚴。          
        </div>
        </div>
      </div>

      <div className="featured-services">
        <div className="featured-services-container">
          <h2 className="featured-services-title">特色服務</h2>
          
          {/* Daily Living Service */}
          <div className="service-card">
            <div className="service-card-content">
              <h3 className="service-card-title"> 日常生活服務</h3>
              <p className="service-card-description">
在 Connection Health Care（CHC），我們為長者提供貼心且個人化的日常生活協助。服務
內容包括：個人衛生、穿衣、餐食準備與行動輔助等日常事務，由我們專業團隊細心提供
，重視舒適、尊嚴與獨立性。              
              </p>
              {/* <ul className="service-list">
                <li className="service-list-item">
                  <span className="service-list-bullet">•</span>
                  Personal bathing and grooming assistance
                </li>
                <li className="service-list-item">
                  <span className="service-list-bullet">•</span>
                  Oral hygiene and dental care support
                </li>
                <li className="service-list-item">
                  <span className="service-list-bullet">•</span>
                  Skin care and pressure sore prevention
                </li>
              </ul> */}
            </div>
            <div className="service-image-container">
              <img 
                src="caring5.jpg" 
                alt="Hygiene Care Services" 
                className="service-image"
                style={{ objectPosition: 'center 5%' }}
              />
            </div>
          </div>

          {/* Health Care Service */}
          <div className="service-card service-card-reversed">
            <div className="service-card-content">
              <h3 className="service-card-title">個人化照護服務</h3>
              <p className="service-card-description">
                在 Connection Health Care（CHC），我們提供完善的資源，為您量身打造符合日常作息並
貼合個別需求的照護計畫。
我們將與您一同設計一套支持您身心健康的照護方案，讓您安心，也讓您的家人更放心。
              </p>
              {/* <ul className="service-list">
                <li className="service-list-item">
                  <span className="service-list-bullet">•</span>
                  Vital signs monitoring and health assessments
                </li>
                <li className="service-list-item">
                  <span className="service-list-bullet">•</span>
                  Medication management and administration
                </li>
                <li className="service-list-item">
                  <span className="service-list-bullet">•</span>
                  Chronic condition management and support
                </li>
              </ul> */}
            </div>
            <div className="service-image-container">
              <img 
                src="/live-in.jpg" 
                alt="Live-in Care Services" 
                className="service-image"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="testimonial-section">
        <hr className="testimonial-divider" />
        <p className="testimonial-text">
          我們提供所有工具，以制定尊重您的日常生活並圍繞您的需求量身定制的護理計劃。我們將共同設計一個支持您的健康護理計劃，同時讓您的孩子安心。
        </p>
        <hr className="testimonial-divider" style={{ margin: '32px auto 0' }} />
      </div>

      <div className="Why-header steps-section" id="why-we-are">
        <h1 className="hero-title-2 steps-section-title">尋找最專業的護理</h1>
        <div className="steps-container">
          <div className="steps-timeline">
            
            {/* Step 1: Book a Consultation */}
            <div className="step-container">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3 className="step-title">聯繫我們</h3>
                <p className="step-description">通過電子郵件或電話與我們聯繫，我們的團隊成員將協助您。</p>
              </div>
            </div>
            
            {/* Step 2: Assessment */}
            <div className="step-container">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3 className="step-title">添加您的信息</h3>
                <p className="step-description">提供有關您或您所愛之人的需求和偏好的詳細信息，以幫助我們量身定制服務。</p>
              </div>
            </div>
            
            {/* Step 3: Quotation */}
            <div className="step-container">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3 className="step-title">選擇您的服務</h3>
                <p className="step-description">從我們的一系列個性化護理服務中選擇，以最佳滿足您的需求。</p>
              </div>
            </div>
            
            {/* Step 4: Contract */}
            <div className="step-container">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3 className="step-title">放鬆並等待</h3>
                <p className="step-description">我們的工作人員和系統將處理所有細節，並在每個步驟中保持您知情。只需等待更新出現在您的日曆上，然後接受即可。</p>
              </div>
            </div>
            
            {/* Step 5: Service */}
            <div className="step-container">
              <div className="step-number">5</div>
              <div className="step-content">
                <h3 className="step-title">享受服務</h3>
                <p className="step-description">我們開始提供個性化護理，專業護理人員或個人服務工作者將在家中照顧您的老年親人。每日護理日誌將進行更新並與家人共享。</p>
              </div>
            </div>
          </div>
        </div>
      </div>

  <ContactFormChinese />
  <FooterChinese />
    </div>
  );
}

export default HomeChinese;
